import {
    MDBAlert,
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBSpinner,
    MDBInput,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { addBlfGroup, confirmDeleteBlfGroupInPhones, getAccountLevelBlfGroups, removeBlfGrp } from '../../../apiclients/streamsapi_bridge';
import PopupLoader from "../../../views/popups/PopupLoader";
import AddBlfGroups from "../../../views/popups/phonesystem/AddBLFGroup";
import RemoveBlfGroups from '../../../views/popups/phonesystem/RemoveBlfGroup';
import { Tooltip } from "react-tooltip";
import UIConstant from "../../../apiclients/UIConstant";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import TabIDConstant from "../../../apiclients/TabIDConstant";
import { useRef } from "react";


function Blfgroups(props) {
    console.log("request came to blf groups:::::::::::::");
    const navigate = useNavigate();
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [addBLF, setAddBLF] = useState(false);
    const [blfGroupsDataTable, setBlfGroupsDataTable] = useState([]);
    const [removeBlfGroup, setRemoveBlfGroups] = useState(false);
    const [rmvGroupDetails, setRmvGroupDetails] = useState({});
    const [blfGroupInfo,setBlfGroupInfo] = useState({});
    const toggleBlfPopup = () => setAddBLF(!addBLF);
    const toggleRemoveBlfpopup = async () => setRemoveBlfGroups(!removeBlfGroup);
    const [accountBlfGroups, setAccountBlfGroups] = useState([]);
    const [isloading, setLoader] = useState(false);
    const [removeSuccessMessage, setRemoveSuccessMessage] = useState("");
    const [searchValue,setsearchValue] = useState("");
    const [fullBlfGroups, setFullBlfGroups] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, props?.active); 
    /* const blfGroupsData = {
        columns: [
            { label: "BLF Group", field: "blfGroup", sort: true },
            { label: "Remove", field: "Remove", sort: false },
        ],
        rows: [
            {
                blfGroup: "Poly VVX 601",
                Delete: <MDBIcon fas icon="times" className="green ms-3" />,
            },
            {
                blfGroup: "Poly VVX 601",
                Delete: <MDBIcon fas icon="times" className="green ms-3" />,
            },

        ],
    }; */
    const blfGroupsData = {
        columns: [
            { label: "BLF Group", field: "blfGroup", sort: true },
            { label: "Remove", field: "Delete", sort: false },
        ],
        rows: blfGroupsDataTable,
    };

    const deleteBlfpopup = async (e, blfgroup) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("[deleteBlfpopup] deleting blf group : " + blfgroup);
        if (blfgroup != null && blfgroup !== 'undefined' && Object.keys(blfgroup).length > 0) {
            console.log("[deleteBlfpopup] deleting blf group : " + blfgroup);
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            let paramjo = {};
            paramjo.siteid = siteid;
            paramjo.blf_group_id = blfgroup.blf_group_id;
            let serverResponse = await confirmDeleteBlfGroupInPhones(siteid, paramjo);
            if (!serverResponse.ok) {
                console.log("Network response was not ok !! delete BLF Group");
            } else {
                let response = await serverResponse.json();
                if (response.configuredMacs.length > 0) {
                    let macAdress = "";
                    let macs = response.configuredMacs;
                    console.log("macs ::::::::::::::: " + macs);
                    for (let item of macs) {
                        console.dir("item ::::: " + item);
                        macAdress += item.macaddress + " ";
                    }
                    blfgroup.devices = macAdress.trim();
                    // setUserInfo(blfgroup);
                    setBlfGroupInfo(blfgroup);
                    setRmvGroupDetails(blfgroup);

                    console.dir(response);
                } else {
                    setBlfGroupInfo(blfgroup);
                    setRmvGroupDetails(blfgroup);
                }
                setRemoveBlfGroups(!removeBlfGroup);
            }
        }
    }


    const deleteBlfGroup = async (jo) => {
        console.log("[deleteBlfGroup] " + JSON.stringify(jo));
        try {
            //  console.log(" popup status  : " + removeBlfGroup);
            if (jo != null && jo !== 'undefined' && Object.keys(jo).length > 0) {
                let paramjo = {};
                let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
                paramjo.site_id = siteid;
                paramjo.blf_group_id = jo.blf_group_id;
                paramjo.reqid = 41;
                paramjo.groupName = jo.group_name
                console.log("Sending request for deleteBlfGroup params : " + JSON.stringify(paramjo));
                let apiResponse = await removeBlfGrp(siteid, paramjo);
                if (!apiResponse.ok) {
                    throw new Error('Network response was not ok');
                } else {
                    console.log(" popup status  : " + removeBlfGroup);
                    setRemoveBlfGroups(!removeBlfGroup);
                    fetchAccountLevelBlfGroups();
                    console.log("Group is deleted successfully :" + jo.group_name + " popup status " + removeBlfGroup);
                    localStorage.setItem("s_message", `BLF Group ${jo.group_name} removed successfully.`);
                    navigate("/pslanding", {
                        state: { tab: "tab4" },
                    });
                    window.location.reload();
                }
            }
        } catch (e) {
            console.log("[deleteBlfGroup] Error while making api request :" + e);
        }
    }

    const fetchAccountLevelBlfGroups = async () => {
        try {
            console.log("[fetchAccountLevelBlfGroups] :");
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            setLoader(true);
            let apiResponse = await getAccountLevelBlfGroups(siteid, TabIDConstant.BLF_GRPS_SUBLINK);
            console.dir(apiResponse);
            if (!apiResponse.ok) {
                setLoader(false);
                console.log("got an issue in fetchAccountLevelBlfGroups with node server ");
                throw new Error('Network response was not ok');
            } else {
                setTimeout(() => {
                    setLoader(false);
                }, 1000);
                let responseData = await apiResponse.json();
                let blfgroupdata = await responseData.blfGroupsList; /*  [{"id":2,"group_name":"Ganesh","site_id":3628},{"id":3,"group_name":"yella","site_id":3628},{"id":4,"group_name":"Nagoor","site_id":3628}] */
                console.log("[fetchAccountLevelBlfGroups] Blfs Groups data from node server :" + JSON.stringify(blfgroupdata));
                let frameBlfGroupsInputdata = [];
                if (blfgroupdata.length > 0) {
                    blfgroupdata.map((element) => {
                        var jo = {};
                        jo.blfGroup = element.group_name;
                        jo.id = element.blf_group_id;
                        jo.Delete =
                            <div className="d-flex align-items-center justify-content-center ms-2">
                                <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deleteBlfpopup(e, element)}>
                                    <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                                </div>
                            </div>
                        // <MDBIcon fas icon="times" className="green ms-3" title="Remove" onClick={(e) => deleteBlfpopup(e, element)} />
                        frameBlfGroupsInputdata.push(jo);
                    })
                    setAccountBlfGroups(blfgroupdata);
                    setFullBlfGroups(blfgroupdata);

                } else {
                    console.log("No BLF groups found for site ID :" + siteid);
                }
                setBlfGroupsDataTable(frameBlfGroupsInputdata);
                setFullBlfGroups(frameBlfGroupsInputdata)
                setTimeout(() => {
                   setDataLoaded(true);  
                },1000)
            }
        } catch (e) {
            console.error("[fetchAccountLevelBlfGroups] Error : " + e);
        }
    }

    const requesttoSaveBlfGroups = async (groupname) => {
        if (groupname && groupname != "" && groupname != null) {
            console.log("[requesttoSaveBlfGroups] :" + groupname);
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            let paramjo = {};
            paramjo.site_id = siteid;
            paramjo.group_name = groupname;
            paramjo.reqid = 40;

            console.log("params :" + JSON.stringify(paramjo));
            let apiresponse = await addBlfGroup(siteid, paramjo);
            if (!apiresponse.ok) {
                console.log("got an issue in requesttoSaveBlfGroups with node server ");
                throw new Error('Network response was not ok');
            } else {
                setAddBLF(!addBLF);
                fetchAccountLevelBlfGroups();
                localStorage.setItem("s_message", `BLF Group ${groupname} added successfully.`);
                navigate("/pslanding", {
                    state: { tab: "tab4" },
                });
                window.location.reload();
            }
        }
    }
    const showThisInf = (row) => {
        console.log("[showThisInf] action on groupinfo :" + JSON.stringify(row));
        let groupinfojo = { groupid: row.id, groupname: row.blfGroup }
        navigate("/blfdetails", { state: { groupid: row.id, groupInfo: groupinfojo } });
    }


    useEffect(() => {
        fetchAccountLevelBlfGroups();
    }, []);

    const handleBlfSearch = (searchValue) => {
        try {
            setsearchValue(searchValue);
            const filteredBlfGroups = customSearch(fullBlfGroups, searchValue, UIConstant.BLFGROUPS_FIELDS);
            setBlfGroupsDataTable(filteredBlfGroups);
        } catch (error) {
            console.log("[handleBlfSearch] Error" + error);
        }
    }


    return (
        <>
            <h5 className="tabcontent actionbar">
                <MDBBtn
                    className="btn btn-primary green-button display-inline float-right"
                    onClick={toggleBlfPopup}
                >
                    <MDBIcon fas icon="plus" size="sm" /> {t("addBLFGroup")}
                </MDBBtn>
            </h5>
            <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search" 
                ref={searchRef}
                value={searchValue} 
                onChange={(e) => handleBlfSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className='blfdatatable'>
                <MDBDatatable
                   // search
                   key={searchValue}
                    sortField="BLF Group"
                    noFoundMessage={t("NotFoundMessage")}
                    entries={UIConstant.DEFAULT_PAGINATION}
                    data={blfGroupsData}
                    className="mt-2 actioncolumnbig"
                    onRowClick={(row) => showThisInf(row)}
                />
            </div>
            {addBLF && (
                <PopupLoader
                    title={"Add BLF Group"}
                    content={<AddBlfGroups accountBlfGroups={accountBlfGroups} onClose={toggleBlfPopup} onsave={requesttoSaveBlfGroups} />}
                    className={""}
                    onShow={setAddBLF}
                    onClose={toggleBlfPopup}
                />
            )}
            {removeSuccessMessage && (
                <MDBAlert
                    open
                    color="success"
                    position="bottom-right"
                    delay={1000}
                    className="alert-center"
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{removeSuccessMessage}</span>
                </MDBAlert>
            )}
            {removeBlfGroup && (
                <PopupLoader
                    title={"Remove BLF Group"}
                    content={<RemoveBlfGroups groupInfo={rmvGroupDetails} onsave={deleteBlfGroup} onClose={toggleRemoveBlfpopup} />}
                    className={""}
                    onShow={setRemoveBlfGroups}
                    onClose={toggleRemoveBlfpopup}
                />
            )}
            {isloading && (
                <div>
                    <div className="loadingclass-popup"></div>
                    <div className="popup-bg-loader loader_align">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </div>
            )}

            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    )

}

export default Blfgroups;